import Card from "components/card";
import React, { useEffect } from "react";
import { Table, Input } from 'antd';
import CrudOption from "components/dropdown/crudoption";
import { connect } from "react-redux";
import { 
	getPayrunList, doPayrunUpdate, doPayrunDelete
} from "../../../../redux/payrun/payrunState";
import { NumberFormatter } from "../../../../utils/index";
import { EyeOutlined } from '@ant-design/icons';
import ColumnSearchFilter from 'components/search/ColumnSearchFilter';
import { handleTableChange } from "../../../../utils/index";

const { Search } = Input;

const PayrollPayrunTable = (props) => {
	
  const { payrunList, pagination, getPayruns, payrollId, payrunUpdate, payrunDelete, filters } = props;
	const { getColumnSearchProps } = ColumnSearchFilter();

  const columns = [
    {
        title: `Employee ID`,
        dataIndex: 'ppr_employee_code',
        key: 'ppr_employee_code',
        width: '12%', 
				...getColumnSearchProps('ppr_employee_code'),
    },
    {
        title: `Employee`,
        dataIndex: 'ppr_employee_name',
        key: 'ppr_employee_name',
        width: '21%',  
				...getColumnSearchProps('ppr_employee_name'),
    },
    {
        title: <div className="text-right">Net Pay</div>,
        dataIndex: 'ppr_net_pay',
        key: 'ppr_net_pay',
        width: '12%',
       	render: (ppr_net_pay) => <div className="text-right">{NumberFormatter(ppr_net_pay)}</div>
    },    
	{
        title: `Type`,
        dataIndex: 'ppr_type_name',
        key: 'ppr_type_id',
        width: '15%',
    },
    {
        title: `Status`,
        dataIndex: 'ppr_status_name',
        key: 'ppr_status_name',
        width: '15%',
        
    },
	{
        title: `Notes`,
        dataIndex: 'ppr_notes',
        key: 'ppr_notes',
        width: '20%',
        
    },
    {
        title: '',
        dataIndex: 'ppr_id',
        key: 'ppr_id',
        width: '5%',
        render:(ppr_id, record) => 
        	<CrudOption 
        		baseRoute={`/console/payrolls/${payrollId}/payruns`} 
        		recordId={ppr_id}
        		allowDelete={record?.ppr_status_id <= 8 || record?.ppr_type_id === 82}
        		allowEdit={false}
				allowExclude={record?.ppr_status_id <= 8}
				allowForFinalPay={record?.ppr_type_id === 85}
				deleteHandler={onDeleteHandler}
				excludeHandler={onExcludeHandler}
				forFinalPayHandler={onForFinalPayHandler}
        		additionalMenu={record?.ppr_status_id === 10 ? [
						{
						    key: 'view-payslip',
						    label: (
								<a href={`/private/view-payslip/${record?.ppr_employee_code}/${record?.ppr_payroll_id}/${btoa(record?.ppr_hash)}/${btoa(record?.ppr_pin)}`} target="_blank" rel="noreferrer">
									View Payslip
								</a>
						    ),
						    icon: <EyeOutlined />,
						    available: 1,
					  	}
					]: []}
        		/>        
    },
    ];
	
	useEffect(() => {
	    if (payrollId > 0) {
	        getPayruns({payrollId: payrollId, paginate: pagination.per_page});
	    }
	}, [getPayruns, payrollId, pagination.per_page]);
	
	const onPayrunSearch = (value, _e, info) => {
		getPayruns({payrollId: payrollId, paginate: pagination.per_page, keyword: value});
	}
	
	const paginateList = (paginateData) => {
		getPayruns({payrollId: payrollId, paginate: paginateData.pageSize, page: paginateData.current});
	}

	const onDeleteHandler = (data) => {
		payrunDelete(data)
	}

	const onExcludeHandler = (data) => {
		payrunUpdate({ppr_id: data.recordId, ppr_type_id: 85, update_type: 'change_type'});
	}

	const onForFinalPayHandler = (data) => {
		payrunUpdate({ppr_id: data.recordId, ppr_type_id: 82, update_type: 'change_type'});
	}
	
  	return (
    	<Card extra={"w-full h-full p-4"}>
      		<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
      			
      			<Search className="mb-3" placeholder="input search text" onSearch={onPayrunSearch} style={{ width: 300 }} />
      			
      			<Table
        			dataSource={payrunList} 
		        	columns={columns} 
		          rowKey={(record) => record.ppr_id}
		        	pagination={{...pagination, showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}  
							onChange={handleTableChange(getPayruns, filters)}           	
        		/>
      		</div>
    	</Card>
  	);
};

const mapStateToProps = (state) => ({
	payrunList: state.payrun.payrunList?.items,
	pagination: state.payrun.payrunList?.pagination,
	filters: state.payrun.payrunList?.filters,
});

const mapDispatchToProps = (dispatch) => ({
	getPayruns: (id) => dispatch(getPayrunList(id)),
	payrunUpdate: (id) => dispatch(doPayrunUpdate(id)),
	payrunDelete: (id) => dispatch(doPayrunDelete(id)),
	
});

export default connect(mapStateToProps, mapDispatchToProps)(PayrollPayrunTable);